"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptChargingSessionAttemptsValidation = void 0;
const ChargingSessionAttemptValidation_1 = require("./ChargingSessionAttemptValidation");
class ReceiptChargingSessionAttemptsValidation {
    static isValid(entity) {
        // Validate entity.receipt_transactions for existence and correct type.
        if (entity.receipt_transactions == undefined)
            return false;
        if (!Array.isArray(entity.receipt_transactions))
            return false;
        if (!entity.receipt_transactions.every((elem) => {
            if (!ChargingSessionAttemptValidation_1.ChargingSessionAttemptValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ReceiptChargingSessionAttemptsValidation = ReceiptChargingSessionAttemptsValidation;
